'use client';

import * as React from 'react';
import Image from 'next/image';
import ReactPlayer from 'react-player/lazy';
import { cn } from '@/lib/utils';

import { Play } from '@/components/ui/Icons';
import HeadlessModal from '@/components/shared/HeadlessModal';
import { useTranslations } from 'next-intl';

interface VideoModalProps {
  coverImage?: string;
  videoSrc?: string;
  playButton?: React.ReactNode;
  onPlay?: (state: boolean) => void;
  coverImgClass?: string;
}

const VideoModal: React.FC<VideoModalProps> = ({
  coverImage,
  videoSrc,
  playButton,
  coverImgClass,
}) => {
  const t = useTranslations();
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <div className="lg:flex-auto">
      <div className="relative mt-[50px] h-auto w-full max-lg:container lg:ml-auto lg:mt-0 lg:max-h-[600px] lg:w-full">
        <Image
          src={coverImage ?? '/video-cover.png'}
          width={743}
          height={375}
          sizes="100vw"
          alt="How to vendor work"
          className={cn('h-auto w-full rounded-[20px]', coverImgClass)}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <button
            onClick={() => setIsOpen(true)}
            className=""
            aria-label={t('aria.toggle_to_change_current_state')}
          >
            {playButton ? (
              playButton
            ) : (
              <div className="relative flex h-[66.54px] w-[66.54px] items-center justify-center rounded-full text-primary-700 hover:text-white lg:h-[130px] lg:w-[130px] lg:bg-[url('/video-play-bg.png')]">
                <Play />
              </div>
            )}
          </button>
        </div>
      </div>
      <HeadlessModal
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        dialogPanelClassName="!min-h-min !w-11/12 md:!max-w-[725px] !p-0 !rounded-[10px] !bg-transparent"
        dialogCloseBtnClassName="!hidden"
      >
        <div className="">
          <ReactPlayer
            url={
              videoSrc ||
              'https://www.youtube.com/embed/xK8vXXQwR9U?si=4HJYM9KJsGn7VkMP'
            }
            playing={true}
            height="405px"
            width="720px"
          />
        </div>
      </HeadlessModal>
    </div>
  );
};

export default VideoModal;
